import React, {useEffect, useState} from 'react'
import {CircularProgress} from '@mui/material'
import {Link} from 'react-router-dom'
import {propertyDataType} from '../property/PropertyDataTypes'
import Swal from 'sweetalert2'
import {getTenantProperties} from './RentedPropertiesAPI'
import PaginationComponent from '../PaginationComponent/Pagination'
import CreateTenantTicket from './Components/CreateTenantTicket'

function RentedPropertiesHome() {
  const [apiData, setApiData] = useState<propertyDataType[]>([])
  const [propertyData, setPropertyData] = useState<propertyDataType[]>()
  const [loading, setLoading] = useState<boolean>(true)
  const [noDataFound, setNoDataFound] = useState<boolean>(false)
  const [showCreateTicket, setShowCreateTicket] = useState<boolean>(false)
  const [itemOffset, setItemOffset] = useState<number>(0);
  const [dataLength, setDataLength] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 1;
  const pageCount = Math.ceil(dataLength / itemsPerPage)

  // function to get properties which are already added
  async function getTenantRentedProperties() {
    setLoading(true)
    try {
      const response = await getTenantProperties(itemOffset, itemsPerPage)
      if (response.status === 200) {
        if (response.data.data.length !== 0) {
          setApiData(response.data.data.propertyList)
          setPropertyData(response.data.data.propertyList)
          setDataLength(response.data.data.totalPropertyList)
        } else {
          setNoDataFound(true)
        }
      } else {
        setNoDataFound(true)
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.data.msg.charAt(0).toUpperCase() + response.data.msg.slice(1),
          text: response.data.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    } finally {
      setLoading(false)
    }
  }

  // fetching added properties onload
  useEffect(() => {
    getTenantRentedProperties()
  }, [itemOffset])

  const searchTenant = (name: string) => {
    if (apiData && apiData?.length > 0) {
      let updatedTenant = apiData
      updatedTenant = apiData.filter((item) =>
        item.property_title.toLowerCase().includes(name.toLowerCase())
      )
      setPropertyData(updatedTenant)
    } else {
      return
    }
  }
  return (
    <>
      {loading ? (
        // {* Begin: loader*}
        <div
          className='d-flex justify-content-center align-items-center vh-70'
          style={{height: '70vh'}}
        >
          <CircularProgress />
        </div>
      ) : (
        // {* End: loader*}
        // {* Begin: property page content*}
        <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
          <div className='d-flex flex-column flex-column-fluid'>
            {/* Begin: header for property page */}
            <div className='d-flex align-items-center gap-2 gap-lg-3 justify-content-between mb-5 px-5'>
              {/* Begin: Heading */}
              <h1
                className='page-heading d-flex text-dark fw-bold fs-3 my-0
            flex-column justify-content-center'
              >
                Properties
              </h1>
              {/* End: Heading */}
              <div className='d-flex align-items-center gap-2 gap-lg-3'>
              <input
                  data-kt-user-table-filter='search'
                  placeholder='Search Property'
                  className='form-control form-control-solid w-200px border-2 py-2 px-4 border-secondary'
                  onChange={(e) => {
                    searchTenant(e.target.value)
                  }}
                />
              </div>
            </div>
            {/* End: header for property page */}
            {/* Begin: Table */}
            <div id='table div'>
              <div className={`card mb-5 mb-xl-8`}>
                <div className='card-body py-3'>
                  <div className='table-responsive'>
                    {/* begin::Table */}
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      {/* begin::Table head */}
                      {!noDataFound && (
                        <thead>
                          <tr className='fw-bold text-muted'>
                            {/* <th className='w-25px'>
                            <div className='form-check form-check-sm form-check-custom form-check-solid'>
                              <input
                                className='form-check-input'
                                type='checkbox'
                                value='1'
                                data-kt-check='true'
                                data-kt-check-target='.widget-9-check'
                              />
                            </div>
                          </th> */}
                            <th className='max-w-150px'>Property Name</th>
                            <th className='max-w-50px'>Details</th>
                            <th className='max-w-200px'>Address</th>
                            <th className='max-w-100px'>Rent</th>
                            <th className='max-w-150px'>Actions</th>
                          </tr>
                        </thead>
                      )}
                      {/* end::Table head */}
                      {/* begin::Table body */}
                      <tbody>
                        {noDataFound ? (
                          <tr>
                            <td colSpan={5}>
                              <span className='d-flex flex-column align-items-center flex-start p-10'>
                                <img
                                  src='/media/svg/undraw/property.svg'
                                  alt='No document uploaded'
                                  className='h-200px w-200px'
                                />
                                <span className='fw-bold text-muted fs-1 text-center'>
                                  No properties added
                                </span>
                              </span>
                            </td>
                          </tr>
                        ) : (
                          propertyData?.map((property, index: number) => {
                            return (
                              <tr key={index}>
                                {/* <td>
                                <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                  <input
                                    className='form-check-input widget-9-check'
                                    type='checkbox'
                                    value='1'
                                  />
                                </div>
                              </td> */}
                                <td className='max-w-150px'>
                                  <div className='d-flex align-items-center'>
                                    <div className='symbol symbol-45px me-3'>
                                      <span className='symbol symbol-50px me-2'>
                                        <span className='symbol-label bg-light-primary'>
                                          {property.property_img_url ? (
                                            <div className='symbol symbol-50px'>
                                              <img
                                                src={property.property_img_url}
                                                alt='Property icon'
                                                style={{objectFit: 'cover'}}
                                              />
                                            </div>
                                          ) : (
                                            <i className='bi bi-house-door fs-2x btn btn-active-color-primary'></i>
                                          )}
                                        </span>
                                      </span>
                                    </div>
                                    <div className='d-flex justify-content-start flex-column'>
                                      <Link
                                        to={`/property/${property.property_uuid}/overview`}
                                        className='text-dark fw-bold text-hover-primary fs-6'
                                        title={
                                          property.property_title.charAt(0).toUpperCase() +
                                          property.property_title.slice(1)
                                        }
                                      >
                                        <div className='text-truncate max-w-150px'>
                                          {property.property_title.charAt(0).toUpperCase() +
                                            property.property_title.slice(1)}
                                        </div>
                                      </Link>
                                      <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                        {property.property_type_name}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td className='max-w-150px'>
                                  <div className='d-flex align-items-center'>
                                    <div className='d-flex justify-content-start flex-column'>
                                      <span
                                        className='text-dark fw-bold text-hover-primary fs-6'
                                      >
                                        <div className='text-truncate max-w-150px'>
                                          {property.property_furnishing_status === 1
                                            ? 'Unfurnished'
                                            : property.property_furnishing_status === 2
                                            ? 'Semi Furnished'
                                            : property.property_furnishing_status === 3
                                            ? 'Fully Furnished'
                                            : 'not available'}
                                        </div>
                                      </span>
                                      <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                        {property.property_usage_type}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td className='max-w-150px'>
                                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                    {property.property_address.charAt(0).toUpperCase() +
                                      property.property_address.slice(1)}
                                  </span>
                                </td>
                                <td className='max-w-100px'>
                                  <span className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                    {`₹ ${property.current_rent}`}
                                  </span>
                                </td>
                                
                                <td className='max-w-200px'>
                                  <div className='d-flex flex-shrink-0'>
                                    <Link
                                      to={`/rented-properties/${property.property_uuid}`}
                                      className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    >
                                      <i
                                        className='bi bi-cash-stack bi-4x fs-3'
                                        title='Rent information'
                                      ></i>
                                    </Link>
                                  
                                    <div
                                      className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      onClick={() => setShowCreateTicket(true)}
                                    >
                                      <i
                                        className='bi bi-ticket-detailed bi-4x fs-3'
                                        title='Create Ticket'
                                      ></i>
                                    </div>

                                    {showCreateTicket && (
                                      <CreateTenantTicket
                                      showCreateTicketModal = {showCreateTicket}
                                        handleClose={() => setShowCreateTicket(false)}
                                        property_uuid = {property.property_uuid}
                                      />
                                    )}
                                  </div>
                                </td>
                              </tr>
                            )
                          })
                        )}
                      </tbody>
                      {/* end::Table body */}
                    </table>
                    {/* end::Table */}
                  </div>
                </div>
              </div>
            </div>
            {/* End: Table */}

            {/* Begin: Pagination */}
            {
              propertyData && pageCount>1 && <PaginationComponent itemsPerPage={itemsPerPage} dataLength={dataLength} setItemOffset={setItemOffset} currentPage={currentPage} setCurrentPage={setCurrentPage}
              pageCount = {pageCount}/>
            }
            {/* End: Pagination */}
          </div>
        </div>
        // {/* End: property page content */}
      )}
    </>
  )
}

export default RentedPropertiesHome
